module.exports = "/static/assets/d0658279229463ee5e53850f4cfea6d3.png";